import styled, { css } from "styled-components";
import { lighten } from "polished";

import { IStyleProps } from "./interfaces";

export const ScrollWrap = styled.div<IStyleProps>`
    height: 100%;
    overflow: hidden;
    ${p =>
        p.isLow &&
        css`
            width: 666px;
            height: 375px;
            border: 2px solid black;
            border-radius: 30px;
            margin: auto;
            margin-top: 105px;
            background-color: white;
        `}
`;

export const Scroll = styled.div`
    height: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        width: 8px;
        height: 12px;
        background-color: ${p => p.theme.c.greyE}; /* or add it to the track */
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${p => lighten(0.04, p.theme.c.pale)};
    }
`;

export const Wrap = styled.div`
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    min-width: 100%;
`;

export const StaffLines = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const StaffLine = styled.div<IStyleProps>`
    width: 100%;
    background-color: ${p => p.isChristmas ? p.theme.c.christmasBlue : "black"};
    position: relative;
`;

export const System = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
`;

export const Clef = styled.div<IStyleProps>`
    position: relative;
    height: ${p => 230 * (p.isLow ? 0.5625 : 1)}px;
    svg {
        fill: ${p => p.isChristmas ? p.theme.c.christmasBlue : "black"};
    }
`;

export const Accidental = styled.div`
    position: relative;
    display: inline-block;
    span {
        color: black;
        display: inline-block;
    }
`;

export const Accidentals = styled.div`
    display: flex;
`;

const ModifierButton = styled.div<IStyleProps>`
    position: absolute;
    padding: 0 24px;
    top: 15px;
    color: ${p => p.active ? p.theme.c.boost : p.theme.c.black};
    cursor: pointer;
    span {
        font-size: 56px;
        font-weight: 600;
        line-height: 66px;
        display: inline-block;
    }
`;

export const StyledSharpButton = styled(ModifierButton)`
    left: 930px;
`;

export const StyledFlatButton = styled(ModifierButton)`
    left: 763px;
    span {
        transform: rotate(180deg);
    }
`;

export const StyledNaturalButton = styled(ModifierButton)`
    left: 846px;
    font-size: 30px;
    line-height: 68px;
    font-weight: 600;
    padding: 0 29px;
    margin-left: 15px;
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;

    img {
        width: 756px;
        display: block;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    top: 482px;
    left: 450px;
    pointer-events: none;
    img {
        width: 407px;
    }
`;
export const Asset3Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    pointer-events: none;
    img {
        width: 407px;
    }
`;

export const OctaveMark = styled.div`
    position: absolute;
    i {
        color: ${p => p.theme.c.black};
    }
    transform: skewX(-10deg);
`;

export const DoClef = styled.div`
    position: relative;
    font-weight: 400;
    color: ${p => p.theme.c.black};
    height: 0;
`;

export const ClefLedger = styled.div`
    position: absolute;
    background-color: ${p => p.theme.c.black};
`;

export const ClefLedgerHolder = styled.div`
    position: relative;
`;
